import { RootState } from '../../types';

export const all = (state: RootState) => state.games.lists;
export const byId = (state: RootState, id: number) =>
  state.games.lists[id] || {};
